<template>
    <div class="game-container">
      <div class="game-header">
        <img src="/LOGO_BFG.svg" alt="">
        <span class="time-container">
          <img src="../assets/images/timer.svg" alt="">
          <span>00:00.00</span>
        </span>
      </div>
      <div class="game-main">
        <game-background></game-background>
        <div class="game-instructions-container">
            <div>
              <h2>Instrucciones del juego</h2>
            </div>

            <p>
             Toca las piezas de la cuadrícula hasta posicionarlas correctamente.
             Al iniciar tienes sólo un minuto para completarlo,
             hacerlo en el menor tiempo posible te dará más posibilidades de ganar.
            </p>
            <!-- <h3>¡A JUGAR!</h3> -->
            <div>
              <button
                class="btn-game-primary"
                @click="closeInstructions">¡COMENZAR A JUGAR!</button>
            </div>

          </div>
      </div>
  </div>
</template>

<script>

import GameBackground from './game-background.vue'
export default {
  name: 'GameInstructions',
  components: {
    GameBackground
  },
  methods: {
    closeInstructions () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
 @import "../assets/styles/variables";

  .btn-close-instructions {
    height: 30px;
    width: 30px;
    padding: 0;
    position: absolute;
    top: 20px;
    right: 20px;
    border-radius: 15px;
    background-color: transparent;
    outline: none !important;
    border: 1px solid #ffffff;
    cursor: pointer;
  }
  .instructions-inner {
    text-align: center;

  }
    $cardMap: (
      401px: 100px,
      801px: 140px,
      1400px: 200px,
    );

    $card: 80px;
    $cardGrid: 4;
    .game-instructions-container{
        transition: all .25s ease-in-out;
        box-sizing: border-box;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 30px;
        height: $card * $cardGrid;
        width: $card * $cardGrid;
        h2{
          margin: 0 0 15px;
          font-size: 18px;
        }
        p{
          color: $game-primary-font-color;
          line-height: 25px;
          font-size: 13px;
          margin: 0 0 30px;
        }
    }

@each $size, $cardSize in $cardMap {
  @media screen and (min-width: $size){
    $card: $cardSize;
    .game-instructions-container{
        height: $card * $cardGrid;
        width: $card * $cardGrid;
    }
  }
}
 @media screen and (min-width: 801px){
   .game-instructions-container{
      padding: 0 80px;
      h2{
        font-size: 36px;
        width: 300px;
      }
      p{
        font-size: 20px;
        line-height: 35px;
      }
    }
  }

</style>
